;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:propstrata-app":true});}catch(e){}}();import { isWorkflowProtectedViewName } from "@/lib/constants/protected-workspace-views";

export function partitionWorkspaceViews<T extends { name: string }>(
	views: T[],
): { dashboardViews: T[]; workflowViews: T[] } {
	const dashboardViews: T[] = [];
	const workflowViews: T[] = [];

	for (const view of views) {
		if (isWorkflowProtectedViewName(view.name)) {
			workflowViews.push(view);
			continue;
		}

		dashboardViews.push(view);
	}

	return { dashboardViews, workflowViews };
}
